
<template>
  <div>
    <Logo :parentData="pageData" />
    <BackStageMenu :parentData="pageData" />

    <div id="contents" class="clearfix" style="min-height: 470px">
      <div id="main_area">
        <div class="information">
          <h3>{{ pageData.MenuName }}</h3>
          <div class="table_scroll2">
            <table class="newTable">
              <tbody>
                <tr>
                  <td>服務機關：</td>
                  <td>
                    <select
                      v-model="form.jobGovCode1"
                      style="min-width: 200px"
                      @change="JobGovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode2"
                      style="min-width: 200px"
                      @change="JobGovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode3"
                      style="min-width: 200px"
                      @change="JobGovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.jobGovCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum &&
                        loginInfo.govCode != '355010000I' &&
                        loginInfo.govCode != 'A11100000F'
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.jobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.jobGovCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>受理申報機關：</td>
                  <td>
                    <select
                      v-model="form.govCode1"
                      style="min-width: 200px"
                      @change="GovCode1Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        1 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode2"
                      style="min-width: 200px"
                      @change="GovCode2Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        2 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode3"
                      style="min-width: 200px"
                      @change="GovCode3Change()"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        3 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="form.govCode4"
                      style="min-width: 200px"
                      :disabled="
                        loginInfo &&
                        loginInfo.roleSeq != 1 &&
                        4 <= loginInfo.layerNum
                      "
                    >
                      <option
                        v-for="(item, index) in dropDownList.govCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <div>
                      <input
                        type="checkbox"
                        v-model="form.govCheck"
                        true-value="1"
                        false-value="0"
                      />
                      包含所屬機關
                    </div>
                  </td>
                </tr>

                <tr>
                  <td>身分證統一編號：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.idn" />
                  </td>
                </tr>
                <tr>
                  <td>姓名：</td>
                  <td>
                    <input type="text" maxlength="10" v-model="form.name" />
                  </td>
                </tr>
                <tr>
                  <td>在職狀態：</td>
                  <td>
                    <select v-model="form.jobstatus" style="min-width: 480px">
                      <option
                        v-for="(item, index) in dropDownList.onJobs"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </td>
                </tr>
                <tr>
                  <td colspan="6" class="f_center">
                    <input
                      type="submit"
                      class="btn"
                      value="查詢"
                      @click="
                        () => {
                          this.form.currentpage = 1;
                          this.form.pagesize = 10;
                          this.doQuery();
                        }
                      "
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="新增"
                      @click="btnAdd()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="匯入"
                      @click="btnImport()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="匯出"
                      @click="btnExport()"
                    />
                    <input
                      type="submit"
                      class="btn"
                      value="重填"
                      @click="doClear()"
                    />
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <!-- 查詢結果開始-->
    <div class="information">
      <table width="100%">
        <tbody>
          <tr>
            <td>
              <font color="#FF0000"
                >注意：【申報類別】以批次方式執行，每天更新的時間為：AM
                00:00</font
              >
            </td>
            <td v-if="grid && grid.paginaiton" align="right">
              <input
                type="button"
                value="<<"
                class="btn"
                style="height: 28px"
                @click="form.currentpage = grid.paginaiton.pageNo - 1"
                v-show="grid.paginaiton.pageNo > 1"
              />
              <span
                v-for="(data, index) in grid.paginaiton.pages"
                :key="index"
                style="cursor: pointer"
                :style="
                  grid.paginaiton.pageNo == data ? 'color:red' : 'color:black'
                "
                @click="form.currentpage = parseInt(data)"
              >
                {{ grid.paginaiton.pageNo == data ? "[" + data + "]" : data }}
              </span>
              <input
                type="button"
                class="btn"
                value=">>"
                style="height: 28px"
                v-show="grid.paginaiton.pageNo < grid.paginaiton.totalPage"
                @click="form.currentpage = grid.paginaiton.pageNo + 1"
              />
              ［每頁<input
                type="text"
                v-model.number.lazy="form.pagesize"
                size="2"
                maxlength="4"
              />

              <input type="button" class="btn" value="筆" />，第<input
                type="text"
                v-model.number.lazy="form.currentpage"
                size="2"
                maxlength="4"
              />
              <input type="button" class="btn" value="頁" />，共
              {{ grid.paginaiton.totalPage }} 頁
              {{ grid.paginaiton.totalCount }} 筆］
            </td>
          </tr>
        </tbody>
      </table>
      <div class="active">
        <div class="table_scroll2">
          <table width="1060" class="itable">
            <thead>
              <tr>
                <th>操作</th>
                <th style="min-width: 80px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('NAME', Sort);
                      }
                    "
                    >姓名</u
                  >
                </th>
                <th style="min-width: 100px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('IDN', Sort);
                      }
                    "
                    >身分證統一編號</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('JOB_GOV_CODE', Sort);
                      }
                    "
                    >服務機關</u
                  >
                </th>
                <th>受理申報機關</th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('title', Sort);
                      }
                    "
                    >單位及職稱</u
                  >
                </th>
                <th style="min-width: 150px">
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('tel', Sort);
                      }
                    "
                    >聯絡電話</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('arrive_Date', Sort);
                      }
                    "
                    >到職日</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('leave', Sort);
                      }
                    "
                    >現職狀況</u
                  >
                </th>
                <th>
                  <u
                    style="cursor: pointer"
                    target="_blank"
                    @click="
                      () => {
                        this.reQuery('leave_Reason', Sort);
                      }
                    "
                    >備註</u
                  >
                </th>
                <th>申報類別</th>
                <th>新增時間</th>
                <th>最後修改時間</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(data, index) in grid.gridDatas" :key="index">
                <td width="1%" align="center">
                  <input
                    type="button"
                    class="btn"
                    @click="btnEdit(data)"
                    value="編"
                  />
                  <input
                    type="button"
                    class="btn"
                    @click="btnDelete(data)"
                    value="刪"
                  />
                  <input
                    type="button"
                    class="btn"
                    value="機關變動"
                    @click="btnGovCodeEdit(data)"
                  />
                </td>
                <td>{{ data.name }}</td>
                <td>{{ data.idn }}</td>
                <td>{{ data.job_Gov_Code_Str }}</td>
                <td style="white-space: normal">
                  {{ data.goV_CODE_Str }}
                  <a
                    v-show="data.goV_CODE_LOG_FLAG == 'Y'"
                    style="color: red; display: block; cursor: pointer"
                    @click="btnSearchLog(data.idn)"
                    >(變動紀錄)</a
                  >
                </td>
                <td>{{ data.title }}</td>
                <td>{{ data.tel }}</td>
                <td>{{ data.arrive_Date_str }}</td>
                <td>{{ data.leave_str }}</td>
                <td>{{ data.leave_Reason }}</td>
                <td>{{ data.dtypE_NAME }}</td>
                <td>{{ data.ct_Date_str }}</td>
                <td>{{ data.op_Date_str }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <!-- 查詢結果結束-->
    <PdisFooter />

    <DetailModal
      v-model="DetailModal.show"
      :title="DetailModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>服務機關</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.jobGovCode1"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode1Change()"
                    :disabled="
                      !loginInfo.govCodeStr.includes('305000000C') && ( 
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      1 <= loginInfo.layerNum) || DetailModal.form.authorizeFlag
                      )
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode2"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode2Change()"
                    :disabled="
                      !loginInfo.govCodeStr.includes('305000000C') && ( 
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum &&
                      loginInfo.govCode != '355010000I' &&
                      loginInfo.govCode != 'A11100000F') || DetailModal.form.authorizeFlag
                      )
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode3"
                    style="min-width: 200px"
                    @change="DetailModalJobGovCode3Change()"
                    :disabled="
                      !loginInfo.govCodeStr.includes('305000000C') && ( 
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum &&
                      loginInfo.govCode != '355010000I' &&
                      loginInfo.govCode != 'A11100000F') || DetailModal.form.authorizeFlag
                      )
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.jobGovCode4"
                    style="min-width: 200px"
                    :disabled="
                      !loginInfo.govCodeStr.includes('305000000C') && ( 
                      (loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum &&
                      loginInfo.govCode != '355010000I' &&
                      loginInfo.govCode != 'A11100000F') || DetailModal.form.authorizeFlag
                      )
                    "
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.govCode1"
                    style="min-width: 200px"
                    @change="DetailModalGovCode1Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode2"
                    style="min-width: 200px"
                    @change="DetailModalGovCode2Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode3"
                    style="min-width: 200px"
                    @change="DetailModalGovCode3Change()"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="DetailModal.form.govCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .govCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input
                    type="text"
                    maxlength="20"
                    v-model="DetailModal.form.idn"
                    :disabled="DetailModal.modifyType == 'U'"
                  />
                </td>
                <td>姓名</td>
                <td>
                  <input type="text" v-model="DetailModal.form.name" />
                </td>
              </tr>
              <tr>
                <td>生日</td>
                <td colspan="3">
                  <DatePicker
                    v-model="DetailModal.form.birthday"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr>
                <td>單位及職稱</td>
                <td>
                  <input type="text" v-model="DetailModal.form.title" />
                </td>
                <td>階級</td>
                <td>
                  <select
                    v-model="DetailModal.form.rank"
                    :disabled="
                      !(
                        DetailModal.form.govCode1 == '305000000C' ||
                        DetailModal.form.govCode2 == 'A47010000C'
                      )
                    "
                  >
                    <option value="">無</option>
                    <option value="1">上將</option>
                    <option value="2">中將</option>
                    <option value="3">少將</option>
                    <option value="4">上校</option>
                    <option value="5">中校</option>
                    <option value="6">少校</option>
                    <option value="7">上尉</option>
                    <option value="8">中尉</option>
                    <option value="9">少尉</option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>聯絡電話</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.tel"
                    size="20"
                    maxlength="20"
                  />
                </td>
                <td>E-Mail</td>
                <td>
                  <input
                    type="text"
                    v-model="DetailModal.form.email"
                    size="20"
                    maxlength="40"
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    :disabled="DetailModal.form.authorizeFlag"
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="DetailModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    :disabled="DetailModal.form.authorizeFlag"
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.leave"
                    style="min-width: 480px"
                    :disabled="DetailModal.form.authorizeFlag"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList.onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>應申報身分資格</td>
                <td colspan="3">
                  <select
                    v-model="DetailModal.form.status"
                    style="max-width: 1000px"
                  >
                    <option
                      v-for="(item, index) in DetailModal.dropDownList
                        .OnDeclare"
                      :value="item.mcode"
                      :key="index"
                    >
                      {{ item.mvalue }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="DetailModal.form.leave_Reason"
                      size="80"
                      maxlength="256"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnDetailSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnDetailClear()"
                        :disabled="DetailModal.modifyType == 'U'"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </DetailModal>

    <LogModal
      v-model="LogModal.show"
      :title="LogModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information" v-if="LogModal.grid">
        <table width="100%">
          <tbody>
            <tr>
              <td v-if="LogModal.grid.paginaiton" align="right">
                <input
                  type="button"
                  value="<<"
                  class="btn"
                  style="height: 28px"
                  @click="
                    LogModal.form.currentpage =
                      LogModal.grid.paginaiton.pageNo - 1
                  "
                  v-show="LogModal.grid.paginaiton.pageNo > 1"
                />
                <span
                  v-for="(data, index) in LogModal.grid.paginaiton.pages"
                  :key="index"
                  style="cursor: pointer"
                  :style="
                    LogModal.grid.paginaiton.pageNo == data
                      ? 'color:red'
                      : 'color:black'
                  "
                  @click="LogModal.form.currentpage = parseInt(data)"
                >
                  {{
                    LogModal.grid.paginaiton.pageNo == data
                      ? "[" + data + "]"
                      : data
                  }}
                </span>
                <input
                  type="button"
                  class="btn"
                  value=">>"
                  style="height: 28px"
                  v-show="
                    LogModal.grid.paginaiton.pageNo <
                    LogModal.grid.paginaiton.totalPage
                  "
                  @click="
                    LogModal.form.currentpage =
                      LogModal.grid.paginaiton.pageNo + 1
                  "
                />
                ［每頁<input
                  type="text"
                  v-model.number.lazy="LogModal.form.pagesize"
                  size="2"
                  maxlength="4"
                />

                <input type="button" class="btn" value="筆" />，第<input
                  type="text"
                  v-model.number.lazy="LogModal.form.currentpage"
                  size="2"
                  maxlength="4"
                />
                <input type="button" class="btn" value="頁" />，共
                {{ LogModal.grid.paginaiton.totalPage }} 頁
                {{ LogModal.grid.paginaiton.totalCount }} 筆］
              </td>
            </tr>
          </tbody>
        </table>
        <div class="active">
          <div class="table_scroll2">
            <table width="1060" class="itable">
              <thead>
                <tr>
                  <th>變動時間</th>
                  <th>原受理申報機關</th>
                  <th>新受理申報機關</th>
                  <th>類別</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="(data, index) in LogModal.grid.gridLogDatas"
                  :key="index"
                >
                  <td>{{ data.changE_TIME_STR }}</td>
                  <td>{{ data.olD_GOV_CODE_NAME }}</td>
                  <td>{{ data.neW_GOV_CODE_NAME }}</td>
                  <td>{{ data.kind }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <!-- 查詢結果結束-->
      </div>
    </LogModal>

    <GovCodeModal
      v-model="GovCodeModal.show"
      :title="GovCodeModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="GovCodeModal.form.jobGovCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in GovCodeModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="GovCodeModal.form.jobGovCode2"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in GovCodeModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="GovCodeModal.form.jobGovCode3"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in GovCodeModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="GovCodeModal.form.jobGovCode4"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in GovCodeModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號/居留證號</td>
                <td>
                  <input type="text" v-model="GovCodeModal.form.idn" disabled />
                </td>
                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    v-model="GovCodeModal.form.name"
                    disabled
                  />
                </td>
              </tr>
              <tr>
                <td>到職日</td>
                <td>
                  <DatePicker
                    v-model="GovCodeModal.form.arriveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                    disabled
                  />
                </td>
                <td>去職日</td>
                <td>
                  <DatePicker
                    v-model="GovCodeModal.form.leaveDate"
                    format="YYYMMDD"
                    :isTaiwanYear="true"
                    clearable
                    placeholder="請輸入/選擇日期"
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="GovCodeModal.form.leave"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in GovCodeModal.dropDownList.onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>備註</td>
                <td colspan="3">
                  <p>
                    <input
                      type="text"
                      v-model="GovCodeModal.form.leave_Reason"
                      size="80"
                      maxlength="80"
                    />
                    <br />
                  </p>
                </td>
              </tr>
              <tr>
                <td>新受理申報機關</td>
                <td colspan="3">
                  <p>
                    <select
                      v-model="GovCodeModal.form.newJobGovCode1"
                      style="min-width: 200px"
                    >
                      <option
                        v-for="(item, index) in GovCodeModal.dropDownList
                          .newJobGovCode1s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="GovCodeModal.form.newJobGovCode2"
                      style="min-width: 200px"
                    >
                      <option
                        v-for="(item, index) in GovCodeModal.dropDownList
                          .newJobGovCode2s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="GovCodeModal.form.newJobGovCode3"
                      style="min-width: 200px"
                    >
                      <option
                        v-for="(item, index) in GovCodeModal.dropDownList
                          .newJobGovCode3s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                    <select
                      v-model="GovCodeModal.form.newJobGovCode4"
                      style="min-width: 200px"
                    >
                      <option
                        v-for="(item, index) in GovCodeModal.dropDownList
                          .newJobGovCode4s"
                        :value="item.value"
                        :key="index"
                      >
                        {{ item.text }}
                      </option>
                    </select>
                  </p>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="submit"
                        class="btn"
                        value="存檔"
                        @click="btnGovModalSave()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="btnGovModalClear()"
                        disabled
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </GovCodeModal>

    <ImportModal
      v-model="ImportModal.show"
      :title="ImportModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>上傳檔案</td>
                <td>
                  <input
                    type="file"
                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
                    @change="ImportModalOnFileChange"
                  />
                  <input
                    type="submit"
                    class="btn"
                    value="匯入"
                    @click="ImportModalBtnImport()"
                  />
                </td>
              </tr>
              <tr>
                <td>說明</td>
                <td>
                  <p>
                    【使用說明】：<br />
                    1. 上傳格式說明<br />
                    2.請先下載此範本<a
                      href="/PdpsCli/download/A101_6_sample.xlsx"
                      target="_blank"
                      >sample.xlsx</a
                    ><br />
                    3.依範本方式輸入需要的各項資料(300筆以內)<br />
                    4.儲存檔案 (副檔名需存成.xls)<br />
                    5.再按下上方的「選擇檔案」按鈕，選擇剛儲存的檔案<br />
                    6.按下「匯入」按鈕<br />
                  </p>
                  <!-- 7.在欲匯入的名單前做打勾，按下確認匯入。(不符合系統規則的資料，則無法進行匯入)-->
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ImportModal>

    <ExportModal
      v-model="ExportModal.show"
      :title="ExportModal.title"
      :modalStyle="{ 'max-width': '1200px' }"
    >
      <div class="information">
        <div class="table_scroll2">
          <table class="newTable">
            <tbody>
              <tr>
                <td>年度</td>
                <td colspan="3">
                  <select v-model="ExportModal.form.syear">
                    <option
                      v-for="(data, index) in ExportModal.dropDownList.syears"
                      :key="index"
                      :value="data"
                    >
                      {{ data }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td>受理申報機關</td>
                <td colspan="3">
                  <select
                    v-model="ExportModal.form.jobGovCode1"
                    style="min-width: 200px"
                    disabled
                  >
                    <option
                      v-for="(item, index) in ExportModal.dropDownList
                        .jobGovCode1s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ExportModal.form.jobGovCode2"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      2 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in ExportModal.dropDownList
                        .jobGovCode2s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ExportModal.form.jobGovCode3"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      3 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in ExportModal.dropDownList
                        .jobGovCode3s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <select
                    v-model="ExportModal.form.jobGovCode4"
                    style="min-width: 200px"
                    :disabled="
                      loginInfo &&
                      loginInfo.roleSeq != 1 &&
                      4 <= loginInfo.layerNum
                    "
                  >
                    <option
                      v-for="(item, index) in ExportModal.dropDownList
                        .jobGovCode4s"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                  <div>
                    <input
                      type="checkbox"
                      v-model="ExportModal.form.jobGovCheck"
                      true-value="1"
                      false-value="0"
                    />
                    包含所屬機關
                  </div>
                </td>
              </tr>
              <tr>
                <td>身分證統一編號</td>
                <td>
                  <input
                    type="text"
                    maxlength="10"
                    v-model="ExportModal.form.idn"
                  />
                </td>

                <td>姓名</td>
                <td>
                  <input
                    type="text"
                    maxlength="10"
                    v-model="ExportModal.form.name"
                  />
                </td>
              </tr>
              <tr>
                <td>現職狀況</td>
                <td colspan="3">
                  <select
                    v-model="ExportModal.form.leave"
                    style="min-width: 480px"
                  >
                    <option
                      v-for="(item, index) in ExportModal.dropDownList.onJobs"
                      :value="item.value"
                      :key="index"
                    >
                      {{ item.text }}
                    </option>
                  </select>
                </td>
              </tr>
              <tr>
                <td colspan="6" class="f_center">
                  <label for="checkbox"
                    ><span>
                      <input
                        type="button"
                        class="btn"
                        value="匯出"
                        @click="ExportModalBtnExport()"
                      />
                      <input
                        type="submit"
                        class="btn"
                        value="重填"
                        @click="ExportModalBtnClear()"
                      /> </span
                  ></label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div class="f_center"></div>
      </div>
    </ExportModal>

    <Alert v-model="Alert.show" :title="Alert.title">
      <div style="text-align: center">
        <div
          v-for="(data, index) in Alert.txt"
          :key="index"
          style="margin-bottom: 10px"
        >
          <p>{{ data }}</p>
        </div>
        <div>
          <button class="btn" @click="Alert.BtnConfirm">確定</button>
        </div>
      </div>
    </Alert>

    <AlertDel v-model="AlertDel.show" :title="AlertDel.title">
      <div style="text-align: center">
        <p>確定要刪除資料嗎?</p>
        <div>
          <button class="btn" @click="btnDelSubmit()">確定</button>
          <button class="btn" @click="AlertDel.show = false">取消</button>
        </div>
      </div>
    </AlertDel>
  </div>
</template>

<script>
import VueModal from "@/components/Common/vue-modal.vue";
import VueDatepicker from "@/components/Common/VueDatepickerLocal";
import Logo from "@/components/Common/Logo.vue";
import BackStageMenu from "@/components/BackStage/BackStageMenu.vue";
import moment from "moment";
import PdisFooter from "@/components/Common/PdisFooter.vue";
import { ChkIDorRCNumber, getMenu, logOut } from "@/config/util.js";
import WaitEnd from "@/components/Common/WaitEnd.vue";
import {
  SearchGovCode,
  SearchRGovCode,
  SearchGridOnJob,
  SearchGridOnDeclare,
  A101_Import,
  A101_PrintReport,
  A101_SearchGrid,
  A101_ReSearchGrid,
  A101_Delete,
  A101_Detail,
  A101_SearchLog,
  A101_DetailAddSave,
  A101_DetailEditSave,
  A101_GovCodeEditSave,
} from "@/service/api.js";
export default {
  name: "A101",
  data: function () {
    return {
      pageData: {
        MenuIndex: 1,
        MenuName: "",
        PrgName: "A101",
        ServiceUnit: "PDIS",
        isForceLoginOut: true,
      },
      loginInfo: JSON.parse(sessionStorage.getItem("LoginInfo"))
        ? JSON.parse(sessionStorage.getItem("LoginInfo"))
        : "",
      SessionGovCode: sessionStorage.getItem("Session_GovCode"),
      Sort: "",
      Order: "",
      Numm: 0,
      form: {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        jobstatus: "",
        pagesize: 10,
        currentpage: 1,
      },
      dropDownList: {
        govCode1s: [],
        govCode2s: [],
        govCode3s: [],
        govCode4s: [],
        jobGovCode1s: [],
        jobGovCode2s: [],
        jobGovCode3s: [],
        jobGovCode4s: [],
        //在職狀態
        onJobs: [],
      },
      grid: {},
      DetailModal: {
        show: false,
        title: "",
        form: {
          govCode1: sessionStorage.getItem("Session_GovCode"),
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: sessionStorage.getItem("Session_GovCode"),
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          birthday: "",
          title: "",
          rank: "",
          tel: "",
          email: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //應申報身分資格
          status: "",
          //備註
          leave_Reason: "",
          authorizeFlag:false,
        },
        modifyType: "", //"I,U"
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          OnDeclare: [],
          onJobs: [],
        },
        PreData: {},
      },
      LogModal: {
        show: false,
        title: "",
        form: {
          idn: "",
          pagesize: 10,
          currentpage: 1,
        },
        grid: {},
      },
      GovCodeModal: {
        show: false,
        title: "",
        form: {
          govCode1: sessionStorage.getItem("Session_GovCode"),
          govCode2: "",
          govCode3: "",
          govCode4: "",
          jobGovCode1: sessionStorage.getItem("Session_GovCode"),
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          idn: "",
          name: "",
          arriveDate: "",
          leaveDate: "",
          //現職狀況
          leave: "",
          //備註
          leave_Reason: "",
          newJobGovCode1: "",
          newJobGovCode2: "",
          newJobGovCode3: "",
          newJobGovCode4: "",
        },
        dropDownList: {
          govCode1s: [],
          govCode2s: [],
          govCode3s: [],
          govCode4s: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          newJobGovCode1s: [],
          newJobGovCode2s: [],
          newJobGovCode3s: [],
          newJobGovCode4s: [],
          //在職狀態
          onJobs: [],
        },
        PreData: {},
      },
      ImportModal: {
        show: false,
        title: "",
        form: {
          updloaD_FILE: "",
        },
      },
      ExportModal: {
        show: false,
        title: "",
        form: {
          syear: String(new Date().getFullYear() - 1911),
          jobGovCode1: sessionStorage.getItem("Session_GovCode"),
          jobGovCode2: "",
          jobGovCode3: "",
          jobGovCode4: "",
          jobGovCheck: "0",
          idn: "",
          name: "",
          //現職狀況
          leave: "",
        },
        dropDownList: {
          syears: [],
          jobGovCode1s: [],
          jobGovCode2s: [],
          jobGovCode3s: [],
          jobGovCode4s: [],
          //在職狀態
          onJobs: [],
        },
      },
      Alert: {
        show: false,
        title: "",
        txt: [],
        BtnConfirm: function () {
          this.show = false;
        },
      },
      AlertDel: {
        show: false,
        title: "",
        form: {
          pkno: 0,
        },
      },
    };
  },
  components: {
    Logo,
    BackStageMenu,
    PdisFooter,
    Alert: VueModal,
    AlertDel: VueModal,
    DetailModal: VueModal,
    LogModal: VueModal,
    GovCodeModal: VueModal,
    ImportModal: VueModal,
    ExportModal: VueModal,
    DatePicker: VueDatepicker,
  },
  methods: {
    GovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.govCode1 = self.SessionGovCode;
        form.govCode2 = "";
        form.govCode3 = "";
        form.govCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.govCode1 = govCodeArray[0];
          form.govCode2 = govCodeArray[1];
          form.govCode3 = govCodeArray[2];
          form.govCode4 = govCodeArray[3];
        }
      }
    },
    JobGovCodeInit: function (form) {
      const self = this;
      if (self.SessionGovCode != null) {
        form.jobGovCode1 = self.SessionGovCode;
        form.jobGovCode2 = "";
        form.jobGovCode3 = "";
        form.jobGovCode4 = "";
      } else {
        if (self.loginInfo) {
          let govCodeArray = self.loginInfo.govCodeStr.split(",");
          form.jobGovCode1 = govCodeArray[0];
          form.jobGovCode2 = govCodeArray[1];
          form.jobGovCode3 = govCodeArray[2];
          form.jobGovCode4 = govCodeArray[3];
        }
      }
    },
    //取得服務機關第一層類別
    getSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別
    getSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別
    getSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別
    getSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別
    getSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別
    getSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if (self.loginInfo.govCode == "355010000I") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "355010000I" || x.value == "355020000I"
          );
        } else if (self.loginInfo.govCode == "A11100000F") {
          self.dropDownList.jobGovCode2s = rData.returnObject.filter(
            (x) => x.value == "A11100000F" || x.value == "A11000600F"
          );
        } else {
          self.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別
    getSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別
    getSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態
    getOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.dropDownList.onJobs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //取得服務機關第一層類別 DetailModal
    modalGetSearchGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode1s = rData.returnObject;
      });
    },
    //取得服務機關第二層類別 DetailModal
    modalGetSearchGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode2s = rData.returnObject;
      });
    },
    //取得服務機關第三層類別 DetailModal
    modalGetSearchGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode3s = rData.returnObject;
      });
    },
    //取得服務機關第四層類別 DetailModal
    modalGetSearchGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.govCode4s = rData.returnObject;
      });
    },
    //取得受理申報機關第一層類別 DetailModal
    modalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別 DetailModal
    modalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        if (self.loginInfo.govCode == "355010000I") {
          self.DetailModal.dropDownList.jobGovCode2s =
            rData.returnObject.filter(
              (x) => x.value == "355010000I" || x.value == "355020000I"
            );
        } else if (self.loginInfo.govCode == "A11100000F") {
          self.DetailModal.dropDownList.jobGovCode2s =
            rData.returnObject.filter(
              (x) => x.value == "A11100000F" || x.value == "A11000600F"
            );
        } else {
          self.DetailModal.dropDownList.jobGovCode2s = rData.returnObject;
        }
      });
    },
    //取得受理申報機關第三層類別 DetailModal
    modalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別 DetailModal
    modalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.DetailModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態 DetailModal
    modalGetOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.DetailModal.dropDownList.onJobs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //取得申報身分資格 DetailModal
    modalGetOnDeclare: function () {
      const self = this;
      SearchGridOnDeclare({}).then((rData) => {
        self.DetailModal.dropDownList.OnDeclare = [
          { mcode: "", mvalue: "" },
        ].concat(rData.returnObject);
      });
    },
    //取得受理申報機關第一層類別  GovCodeModal
    govModalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別 GovCodeModal
    govModalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別 GovCodeModal
    govModalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別 GovCodeModal
    govModalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態 GovCodeModal
    govModalGetOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.GovCodeModal.dropDownList.onJobs = [
          { value: "", text: "" },
        ].concat(rData.returnObject);
      });
    },
    //取得新受理申報機關第一層類別  GovCodeModal
    govModalGetSearchNewJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.newJobGovCode1s = rData.returnObject;
      });
    },
    //取得新受理申報機關第二層類別 GovCodeModal
    govModalGetSearchNewJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.newJobGovCode2s = rData.returnObject;
      });
    },
    //取得新受理申報機關第三層類別 GovCodeModal
    govModalGetSearchNewJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.newJobGovCode3s = rData.returnObject;
      });
    },
    //取得新受理申報機關第四層類別 GovCodeModal
    govModalGetSearchNewJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.GovCodeModal.dropDownList.newJobGovCode4s = rData.returnObject;
      });
    },
    ExportModalGetSyearDropDownList: function () {
      let syears = [];
      for (
        let i = new Date().getFullYear() - 1911;
        i > new Date().getFullYear() - 1911 - 4;
        i--
      ) {
        syears.push(i.toString());
      }
      return syears;
    },
    //取得受理申報機關第一層類別 ExportModal
    ExportModalGetSearchJobGovCode1: function () {
      const self = this;
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ExportModal.dropDownList.jobGovCode1s = rData.returnObject;
      });
    },
    //取得受理申報機關第二層類別 ExportModal
    ExportModalGetSearchJobGovCode2: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "2", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ExportModal.dropDownList.jobGovCode2s = rData.returnObject;
      });
    },
    //取得受理申報機關第三層類別 ExportModal
    ExportModalGetSearchJobGovCode3: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "3", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ExportModal.dropDownList.jobGovCode3s = rData.returnObject;
      });
    },
    //取得受理申報機關第四層類別 ExportModal
    ExportModalGetSearchJobGovCode4: function (UP_GOV_CODE) {
      const self = this;
      let GovCode = { UP_GOV_CODE: UP_GOV_CODE, LAYER_NUM: "4", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ExportModal.dropDownList.jobGovCode4s = rData.returnObject;
      });
    },
    //取得在職狀態 ExportModal
    ExportModalGetOnJob: function () {
      const self = this;
      SearchGridOnJob({}).then((rData) => {
        self.ExportModal.dropDownList.onJobs = [{ value: "", text: "" }].concat(
          rData.returnObject
        );
      });
    },
    //第一頁查詢
    doQuery: function () {
      const self = this;
      //清空
      self.Order = "";
      self.Sort = "";
      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        LEAVE: self.form.jobstatus,
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOBGOV: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      A101_SearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    reQuery: function (NM, SC) {
      const self = this;
      if (NM == "" && SC == "") {
        if (self.Order == "" && self.Sort == "") {
          //所謂預設值
          self.Order = "IDN";
          self.Sort = "ASC";
        } else {
          //換頁 self.Order && self.Sort 維持原樣
        }
      } else if (NM == self.Order) {
        //而後的點擊
        if (SC == "ASC") {
          self.Sort = "DESC";
        } else {
          self.Sort = "ASC";
        }
      } else {
        //第一次的點擊
        self.Order = NM;
        self.Sort = "ASC";
      }

      if (!self.checkPage(self.form.currentpage, self.form.pagesize)) return;
      let postData = {
        IDN: self.form.idn,
        NAME: self.form.name,
        LEAVE: self.form.jobstatus,
        GOV: self.form.govCode4
          ? self.form.govCode4
          : self.form.govCode3
          ? self.form.govCode3
          : self.form.govCode2
          ? self.form.govCode2
          : self.form.govCode1
          ? self.form.govCode1
          : "",
        GOVCHECK: parseInt(self.form.govCheck),
        JOBGOV: self.form.jobGovCode4
          ? self.form.jobGovCode4
          : self.form.jobGovCode3
          ? self.form.jobGovCode3
          : self.form.jobGovCode2
          ? self.form.jobGovCode2
          : self.form.jobGovCode1
          ? self.form.jobGovCode1
          : "",
        JOBGOVCHECK: parseInt(self.form.jobGovCheck),
        CURRENTPAGE: self.form.currentpage,
        PAGESIZE: self.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "查詢," + self.Order + "," + self.Sort,
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
        SORT: self.Sort,
        ORDER: self.Order,
      };
      A101_ReSearchGrid(postData).then((rData) => {
        if (rData.result) {
          self.grid = rData.returnObject;
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //第一頁重填
    doClear: function () {
      const self = this;
      self.form = {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        govCheck: "0",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        jobGovCheck: "0",
        idn: "",
        name: "",
        jobstatus: "",
        pagesize: 10,
        currentpage: 1,
      };
      // console.log("doClear :GovCodeInit");
      self.GovCodeInit(self.form);
      self.JobGovCodeInit(self.form);
      self.getSearchGovCode1();
      self.getSearchJobGovCode1();
    },
    //第一頁新增
    btnAdd: function () {
      const self = this;
      self.DetailModal.PreData = {};
      self.DetailModalInit();
      // console.log("btnAdd :btnDetailClear");
      self.btnDetailClear();

      self.Numm = 0; //新增需初始化
      self.DetailModal.modifyType = "I";
      self.DetailModal.title = self.pageData.MenuName + "-新增";
      self.DetailModal.show = true;
    },
    //第一頁匯入
    btnImport: function () {
      const self = this;
      self.ImportModal.title = self.pageData.MenuName + "-匯入";
      self.ImportModal.show = true;
      self.ImportModal.form.updloaD_FILE = "";
    },
    //第一頁匯出
    btnExport: function () {
      const self = this;
      debugger;
      self.ExportModal.show = true;
      self.ExportModal.title = self.pageData.MenuName + "-匯出";
      self.ExportModalBtnClear();
      self.ExportModal.dropDownList.syears =
        self.ExportModalGetSyearDropDownList();
      let GovCode = { UP_GOV_CODE: "", LAYER_NUM: "1", GOV_CODE: "" };
      SearchGovCode(GovCode).then((rData) => {
        self.ExportModal.dropDownList.jobGovCode1s = rData.returnObject;
        if (self.form.govCode2 != "" && self.form.govCode2 != null) {
          GovCode = {
            UP_GOV_CODE: self.form.govCode1,
            LAYER_NUM: "2",
            GOV_CODE: "",
          };
          SearchGovCode(GovCode).then((rData) => {
            self.ExportModal.dropDownList.jobGovCode2s = rData.returnObject;
            self.ExportModal.form.jobGovCode2 = self.form.govCode2;
            if (self.form.govCode3 != "" && self.form.govCode3 != null) {
              GovCode = {
                UP_GOV_CODE: self.form.govCode2,
                LAYER_NUM: "3",
                GOV_CODE: "",
              };
              SearchGovCode(GovCode).then((rData) => {
                self.ExportModal.dropDownList.jobGovCode3s = rData.returnObject;
                self.ExportModal.form.jobGovCode3 = self.form.govCode3;
                if (self.form.govCode4 != "" && self.form.govCode4 != null) {
                  GovCode = {
                    UP_GOV_CODE: self.form.govCode3,
                    LAYER_NUM: "4",
                    GOV_CODE: "",
                  };
                  SearchGovCode(GovCode).then((rData) => {
                    self.ExportModal.dropDownList.jobGovCode4s =
                      rData.returnObject;
                    self.ExportModal.form.jobGovCode4 = self.form.govCode4;
                  });
                }
              });
            }
          });
        }
      });
      if (self.form.govCode2 != "" && self.form.govCode2 != null) {
        self.ExportModalGetSearchJobGovCode2(self.form.govCode1);
        self.ExportModal.form.jobGovCode2 = self.form.govCode2;
      }
      if (self.form.govCode3 != "" && self.form.govCode3 != null) {
        self.ExportModalGetSearchJobGovCode3(self.form.govCode2);
        self.ExportModal.form.jobGovCode3 = self.form.govCode3;
      }
      if (self.form.govCode4 != "" && self.form.govCode4 != null) {
        self.ExportModalGetSearchJobGovCode4(self.form.govCode3);
        self.ExportModal.form.jobGovCode4 = self.form.govCode4;
      }
      //self.ExportModalGetSearchJobGovCode2(self.ExportModal.form.jobGovCode1);
      self.ExportModal.dropDownList.onJobs = self.ExportModalGetOnJob();
    },
    //gird
    //第一頁編
    btnEdit: function (data) {
      const self = this;

      // WaitEnd.methods.send(
      //   () => {
      //     self.btnDetailClear();
      //   },
      //   () => {

      self.DetailModal.PreData = data;
      //self.DetailModalInit();
      self.getDetailData();
      self.DetailModal.modifyType = "U";
      self.DetailModal.title = self.pageData.MenuName + "-編輯";
      self.DetailModal.show = true;
      //   }
      // );
    },
    //第一頁刪
    btnDelete: function (data) {
      const self = this;
      this.AlertDel.show = true;
      this.AlertDel.title = "提醒";
      this.AlertDel.form.pkno = data.pkno;
    },
    btnDelSubmit: function () {
      const self = this;
      A101_Delete({
        pkno: this.AlertDel.form.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "刪",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["刪除成功"];
          self.Alert.BtnConfirm = () => {
            self.doQuery();
            self.Alert.show = false;
            self.AlertDel.show = false;
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.AlertDel.show = false;
          self.Alert.txt = "刪除失敗";
          //self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第一頁服務機關變動
    btnGovCodeEdit: function (data) {
      const self = this;
      if(data.authorizeFlag){
        self.Alert.show = true;
          self.Alert.title = "提醒";
          self.Alert.show = true;
          //self.Alert.txt = ["申報人已參加授權，惟名單尚未派送至介接機關，尚不得修改申報人基本資料，以維申報人授權權益。"];
          self.Alert.txt = ["申報人已參加授權，惟名單尚未派送至介接機關，尚不得執行機關變動功能，以維申報人授權權益。"];
          //self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
      else{
         //init
      self.govModalGetOnJob();
      self.govModalGetSearchJobGovCode1();
      self.govModalGetSearchJobGovCode2(self.GovCodeModal.form.jobGovCode1);
      self.govModalGetSearchNewJobGovCode1();
      self.govModalGetSearchNewJobGovCode2(
        self.GovCodeModal.form.newJobGovCode1
      );
      self.GovCodeModal.PreData = data;
      self.getGovModalData();
      self.GovCodeModal.show = true;
      self.GovCodeModal.title = self.pageData.MenuName + "-機關變動";
      }
    },
    //第一頁服務機關變動紀錄
    btnSearchLog: function (idn) {
      const self = this;
      if (
        !self.checkPage(
          self.LogModal.form.currentpage,
          self.LogModal.form.pagesize
        )
      )
        return;
      self.LogModal.form.idn = idn;
      let postData = {
        idn: self.LogModal.form.idn,
        currentpage: self.LogModal.form.currentpage,
        pagesize: self.LogModal.form.pagesize,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "變動紀錄",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      A101_SearchLog(postData).then((rData) => {
        if (rData.result) {
          self.LogModal.grid = rData.returnObject;
          self.LogModal.show = true;
          self.LogModal.title = "A103申報人資料變動紀錄-查詢";
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
    },
    //第二頁明細init
    DetailModalInit: function () {
      const self = this;
      self.modalGetSearchGovCode1();
      self.modalGetSearchGovCode2(self.DetailModal.form.govCode1);
      self.modalGetSearchJobGovCode1();
      self.modalGetSearchJobGovCode2(self.DetailModal.form.jobGovCode1);
      self.modalGetOnDeclare();
      self.modalGetOnJob();
    },
    //第二頁明細init in 編輯
    DetailModalInittoEdit: function () {
      const self = this;
      WaitEnd.methods.send(
        () => {
          self.modalGetSearchGovCode1();
        },
        () => {
          WaitEnd.methods.send(
            () => {
              if (self.DetailModal.form.govCode1 != "")
                self.modalGetSearchGovCode2(self.DetailModal.form.govCode1);
            },
            () => {
              WaitEnd.methods.send(
                () => {
                  if (self.DetailModal.form.govCode2 != "")
                    self.modalGetSearchGovCode3(self.DetailModal.form.govCode2);
                },
                () => {
                  if (self.DetailModal.form.govCode3 != "")
                    self.modalGetSearchGovCode4(self.DetailModal.form.govCode3);
                }
              );
            }
          );
        }
      );

      WaitEnd.methods.send(
        () => {
          self.modalGetSearchJobGovCode1();
        },
        () => {
          WaitEnd.methods.send(
            () => {
              if (self.DetailModal.form.jobGovCode1 != "")
                self.modalGetSearchJobGovCode2(
                  self.DetailModal.form.jobGovCode1
                );
            },
            () => {
              WaitEnd.methods.send(
                () => {
                  if (self.DetailModal.form.jobGovCode2 != "")
                    self.modalGetSearchJobGovCode3(
                      self.DetailModal.form.jobGovCode2
                    );
                },
                () => {
                  if (self.DetailModal.form.jobGovCode3 != "")
                    self.modalGetSearchJobGovCode4(
                      self.DetailModal.form.jobGovCode3
                    );
                }
              );
            }
          );
        }
      );

      // self.modalGetSearchJobGovCode1();
      // if (self.DetailModal.form.jobGovCode1 != "")
      //   self.modalGetSearchJobGovCode2(self.DetailModal.form.jobGovCode1);
      // if (self.DetailModal.form.jobGovCode2 != "")
      //   self.modalGetSearchJobGovCode3(self.DetailModal.form.jobGovCode2);
      // if (self.DetailModal.form.jobGovCode3 != "")
      //   self.modalGetSearchJobGovCode4(self.DetailModal.form.jobGovCode3);
      self.modalGetOnDeclare();
      self.modalGetOnJob();
    },
    //第二頁明細內容 API
    getDetailData: function () {
      const self = this;
      // for (var i = 0; i < 4; i++) {
      A101_Detail({
        pkno: self.DetailModal.PreData.pkno,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "編",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      }).then((rData) => {
        if (rData.result) {
          WaitEnd.methods.send(
            () => {
              self.DetailModal.grid = rData.returnObject;

              self.DetailModal.form = {
                //取得Radmin_Rel內
                govCode1: self.DetailModal.grid.govCodeStr.split(",")[0],
                govCode2: self.DetailModal.grid.govCodeStr.split(",")[1],
                govCode3: self.DetailModal.grid.govCodeStr.split(",")[2],
                govCode4: self.DetailModal.grid.govCodeStr.split(",")[3],
                jobGovCode1: self.DetailModal.grid.jobGovCodeStr.split(",")[0],
                jobGovCode2: self.DetailModal.grid.jobGovCodeStr.split(",")[1],
                jobGovCode3: self.DetailModal.grid.jobGovCodeStr.split(",")[2],
                jobGovCode4: self.DetailModal.grid.jobGovCodeStr.split(",")[3],
                idn: self.DetailModal.grid.idn,
                name: self.DetailModal.grid.name,
                birthday: self.DetailModal.grid.birthday,
                title: self.DetailModal.grid.title,
                rank: self.DetailModal.grid.rank,
                tel: self.DetailModal.grid.tel,
                email: self.DetailModal.grid.email,
                arriveDate: self.DetailModal.grid.arriveDate,
                leaveDate: self.DetailModal.grid.leaveDate,
                //現職狀況
                leave: self.DetailModal.grid.leave,
                //應申報身分資格
                status: self.DetailModal.grid.status,
                //備註
                leave_Reason: self.DetailModal.grid.leaveReason,
                authorizeFlag : self.DetailModal.grid.authorizeFlag,
              };
              if (self.DetailModal.form.jobGovCode1 != "") self.Numm = 1; //基數歸1
              if (self.DetailModal.form.jobGovCode2 != "") self.Numm = 2; //基數歸2
              if (self.DetailModal.form.jobGovCode3 != "") self.Numm = 3; //基數歸3
              if (self.DetailModal.form.jobGovCode4 != "") self.Numm = 4; //基數歸4
            },
            () => {
              self.DetailModalInittoEdit();
            }
          );
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["權限錯誤，請重新登入．"];
          self.Alert.BtnConfirm = () => {
            logOut(self.pageData.ServiceUnit, self);
          };
        }
      });
      //}
    },
    //第二頁明細新增 API
    A101_DetailAddSave: function () {
      const self = this;
      let postData = {
        pkno: 0,
        joB_GOV_CODE: self.DetailModal.form.jobGovCode4
          ? self.DetailModal.form.jobGovCode4
          : self.DetailModal.form.jobGovCode3
          ? self.DetailModal.form.jobGovCode3
          : self.DetailModal.form.jobGovCode2
          ? self.DetailModal.form.jobGovCode2
          : self.DetailModal.form.jobGovCode1
          ? self.DetailModal.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.DetailModal.form.jobGovCode1 +
          "," +
          self.DetailModal.form.jobGovCode2 +
          "," +
          self.DetailModal.form.jobGovCode3 +
          "," +
          self.DetailModal.form.jobGovCode4,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: moment(self.DetailModal.form.birthday).format("YYYY-MM-DD"),
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE:
          self.DetailModal.form.arriveDate == ""
            ? null
            : moment(self.DetailModal.form.arriveDate).format("YYYY-MM-DD"),
        leavE_DATE:
          self.DetailModal.form.leaveDate == ""
            ? null
            : moment(self.DetailModal.form.leaveDate).format(
                "YYYY-MM-DD, HH:mm:ss"
              ),
        leavE_REASON: self.DetailModal.form.leave_Reason,
        leave: self.DetailModal.form.leave,
        status: self.DetailModal.form.status,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細新增",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      // console.log(JSON.stringify(postData));
      A101_DetailAddSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["新增成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            // self.DetailModal.show = false;
            // console.log("A101_DetailAddSave :btnDetailClear");
            self.btnDetailClear();
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = "新增失敗";
          //self.Alert.txt = [rData.messages[0]];
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
        //console.log(rData);
      });
    },
    //第二頁明細修改 API
    A101_DetailEditSave: function () {
      const self = this;
      let postData = {
        pkno: self.DetailModal.PreData.pkno,
        joB_GOV_CODE: self.DetailModal.form.jobGovCode4
          ? self.DetailModal.form.jobGovCode4
          : self.DetailModal.form.jobGovCode3
          ? self.DetailModal.form.jobGovCode3
          : self.DetailModal.form.jobGovCode2
          ? self.DetailModal.form.jobGovCode2
          : self.DetailModal.form.jobGovCode1
          ? self.DetailModal.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.DetailModal.form.jobGovCode1 +
          "," +
          self.DetailModal.form.jobGovCode2 +
          "," +
          self.DetailModal.form.jobGovCode3 +
          "," +
          self.DetailModal.form.jobGovCode4,
        goV_CODE: self.DetailModal.form.govCode4
          ? self.DetailModal.form.govCode4
          : self.DetailModal.form.govCode3
          ? self.DetailModal.form.govCode3
          : self.DetailModal.form.govCode2
          ? self.DetailModal.form.govCode2
          : self.DetailModal.form.govCode1
          ? self.DetailModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.DetailModal.form.govCode1 +
          "," +
          self.DetailModal.form.govCode2 +
          "," +
          self.DetailModal.form.govCode3 +
          "," +
          self.DetailModal.form.govCode4,
        idn: self.DetailModal.form.idn,
        name: self.DetailModal.form.name,
        rank: self.DetailModal.form.rank,
        tel: self.DetailModal.form.tel,
        email: self.DetailModal.form.email,
        birthday: moment(self.DetailModal.form.birthday).format("YYYY-MM-DD"),
        title: self.DetailModal.form.title,
        userid: self.loginInfo.id,
        arrivE_DATE:
          self.DetailModal.form.arriveDate == ""
            ? null
            : moment(self.DetailModal.form.arriveDate).format("YYYY-MM-DD"),
        leavE_DATE:
          self.DetailModal.form.leaveDate == ""
            ? null
            : moment(self.DetailModal.form.leaveDate).format(
                "YYYY-MM-DD, HH:mm:ss"
              ),
        leavE_REASON: self.DetailModal.form.leave_Reason,
        leave: self.DetailModal.form.leave,
        status: self.DetailModal.form.status,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "第二頁明細修改",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      // console.log(JSON.stringify(postData));
      A101_DetailEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.DetailModal.show = false;
            // console.log("A101_DetailEditSave :btnDetailClear");
            //self.btnDetailClear();
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = "修改失敗";
          //self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第二頁按紐明細存檔
    btnDetailSave: function () {
      const self = this;
      let errorMsg = [];
      if (self.DetailModal.form.idn.trim() == "") {
        errorMsg.push("請填寫身分證統一編號");
      }
      if (!ChkIDorRCNumber(self.DetailModal.form.idn.trim())) {
        errorMsg.push("身分證統一編號格式不對");
      }
      if (self.DetailModal.form.birthday == "") {
        errorMsg.push("請填寫生日");
      } else if (
        new Date(self.DetailModal.form.birthday).getFullYear() >
        new Date(Date.now()).getFullYear() - 20
      ) {
        errorMsg.push("生日錯誤(生日之人尚未成年)");
      }
      if (self.DetailModal.form.email.trim() == "") {
        errorMsg.push("請填寫Email");
      } else if (!(self.DetailModal.form.email.trim().indexOf("@") > -1)) {
        errorMsg.push("Email格式錯誤");
      }
      if (self.DetailModal.form.govCode1 == "") {
        errorMsg.push("請填寫受理申報機關");
      }
      if (self.DetailModal.form.jobGovCode1 == "") {
        errorMsg.push("請填寫服務機關");
      }
      if (self.DetailModal.form.status == "") {
        errorMsg.push("請填寫應申報身分資格");
      }
      if (self.DetailModal.form.title.trim() == "") {
        errorMsg.push("請填寫單位及職稱");
      }
      if (self.DetailModal.form.name.trim() == "") {
        errorMsg.push("請填寫姓名");
      }
      if (self.DetailModal.form.tel.trim() == "") {
        errorMsg.push("請填寫聯絡電話");
      }
      if (self.DetailModal.form.arriveDate == "") {
        errorMsg.push("請填寫到職日");
      } else if (
        self
          .$moment(self.DetailModal.form.leaveDate)
          .isBefore(self.DetailModal.form.arriveDate)
      ) {
        errorMsg.push("去職日需大於到職日");
      }
      // else if (
      //   self.$moment(Date.now()).isBefore(self.DetailModal.form.arriveDate)
      // ) {
      //   errorMsg.push("到職日不可填寫未來日");
      // }
      if (self.DetailModal.form.leave == "") {
        errorMsg.push("請填寫現職狀況");
      } else {
        if (
          self.DetailModal.form.leave == "6" ||
          self.DetailModal.form.leave == "7" ||
          self.DetailModal.form.leave == "11" ||
          self.DetailModal.form.leave == "12" ||
          self.DetailModal.form.leave == "14" ||
          self.DetailModal.form.leave == "15" ||
          self.DetailModal.form.leave == "16" ||
          self.DetailModal.form.leave == "17"
        ) {
          if (self.DetailModal.form.leaveDate == "") {
            errorMsg.push("請填寫去職日");
          }
        }
      }

      if (errorMsg.length > 0) {
        self.Alert.txt = errorMsg;
        self.Alert.show = true;
        self.Alert.title = "提醒";
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return false;
      }

      if (self.DetailModal.modifyType == "I") {
        self.A101_DetailAddSave();
      } else if (self.DetailModal.modifyType == "U") {
        self.A101_DetailEditSave();
      }
    },
    //第二頁明細重填
    btnDetailClear: function () {
      const self = this;
      self.DetailModal.form = {
        govCode1: "",
        govCode2: "",
        govCode3: "",
        govCode4: "",
        jobGovCode1: "",
        jobGovCode2: "",
        jobGovCode3: "",
        jobGovCode4: "",
        idn: "", // self.DetailModal.modifyType == "U" ? self.DetailModal.form.idn : "",
        name: "",
        birthday: "",
        title: "",
        rank: "",
        tel: "",
        email: "",
        arriveDate: "",
        leaveDate: "",
        //現職狀況
        leave: "",
        //應申報身分資格
        status: "",
        //備註
        leave_Reason: "",
      };
      //console.log("btnDetailClear :GovCodeInit");
      self.GovCodeInit(self.DetailModal.form);
      self.JobGovCodeInit(self.DetailModal.form);
      self.modalGetSearchGovCode1();
      self.modalGetSearchJobGovCode1();
    },
    //第三頁 機關變動 API
    getGovModalData: function () {
      const self = this;
      for (var i = 0; i < 4; i++) {
        A101_Detail({
          pkno: self.GovCodeModal.PreData.pkno,
          LogInfo: {
            Id: self.loginInfo.id,
            PrgCode: self.pageData.PrgName,
            ActCd: "機關變動",
            ServiceUnit: self.pageData.ServiceUnit,
            Token: self.loginInfo.token,
          },
        }).then((rData) => {
          if (rData.result) {
            self.GovCodeModal.grid = rData.returnObject;
            self.GovCodeModal.form = {
              pkno: self.GovCodeModal.PreData.pkno,
              govCode1: self.GovCodeModal.grid.jobGovCodeStr.split(",")[0],
              govCode2: self.GovCodeModal.grid.jobGovCodeStr.split(",")[1],
              govCode3: self.GovCodeModal.grid.jobGovCodeStr.split(",")[2],
              govCode4: self.GovCodeModal.grid.jobGovCodeStr.split(",")[3],
              jobGovCode1: self.GovCodeModal.grid.govCodeStr.split(",")[0],
              jobGovCode2: self.GovCodeModal.grid.govCodeStr.split(",")[1],
              jobGovCode3: self.GovCodeModal.grid.govCodeStr.split(",")[2],
              jobGovCode4: self.GovCodeModal.grid.govCodeStr.split(",")[3],
              idn: self.GovCodeModal.grid.idn,
              name: self.GovCodeModal.grid.name,
              arriveDate: self.GovCodeModal.grid.arriveDate,
              leaveDate: self.GovCodeModal.grid.leaveDate,
              //現職狀況
              leave: self.GovCodeModal.grid.leave,
              //備註
              leave_Reason: self.GovCodeModal.grid.leaveReason,
              newJobGovCode1: "", //(self.form.govCode1 == "" ? sessionStorage.getItem("Session_GovCode") : self.form.govCode1),
              newJobGovCode2: "",
              newJobGovCode3: "",
              newJobGovCode4: "",
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = ["權限錯誤，請重新登入．"];
            self.Alert.BtnConfirm = () => {
              logOut(self.pageData.ServiceUnit, self);
            };
          }
        });
      }
    },
    //第三頁服務機關變動 存檔
    btnGovModalSave: function () {
      const self = this;
      const msg = [];
      if (self.GovCodeModal.form.idn.trim() == "")
        msg.push("請填寫身分證統一編號");
      if (!self.GovCodeModal.form.jobGovCode1) msg.push("請填寫受理申報機關");
      if (self.GovCodeModal.form.name.trim() == "") msg.push("請填寫姓名");
      if (!self.GovCodeModal.form.arriveDate) msg.push("請填寫到職日");
      if (!self.GovCodeModal.form.leaveDate) msg.push("請填寫去職日");
      if (!self.GovCodeModal.form.leave) msg.push("請填寫現職狀況");
      if (!self.GovCodeModal.form.newJobGovCode1)
        msg.push("請填寫新受理申報機關");
      else if (
        self
          .$moment(self.GovCodeModal.form.leaveDate)
          .isBefore(self.GovCodeModal.form.arriveDate)
      )
        msg.push("去職日需大於到職日");
      if (
        self.GovCodeModal.form.jobGovCode1 ==
          self.GovCodeModal.form.newJobGovCode1 &&
        self.GovCodeModal.form.jobGovCode2 ==
          self.GovCodeModal.form.newJobGovCode2 &&
        self.GovCodeModal.form.jobGovCode3 ==
          self.GovCodeModal.form.newJobGovCode3 &&
        self.GovCodeModal.form.jobGovCode4 ==
          self.GovCodeModal.form.newJobGovCode4
      ) {
        msg.push("新受理申報機關不可與原受理申報機關相同");
      }
      if (msg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = msg;
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
        return;
      }
      let postData = {
        pkno: self.GovCodeModal.form.pkno,
        joB_GOV_CODE: self.GovCodeModal.form.jobGovCode4
          ? self.GovCodeModal.form.jobGovCode4
          : self.GovCodeModal.form.jobGovCode3
          ? self.GovCodeModal.form.jobGovCode3
          : self.GovCodeModal.form.jobGovCode2
          ? self.GovCodeModal.form.jobGovCode2
          : self.GovCodeModal.form.jobGovCode1
          ? self.GovCodeModal.form.jobGovCode1
          : "",
        joB_GOV_CODE_STR:
          self.GovCodeModal.form.jobGovCode1 +
          "," +
          self.GovCodeModal.form.jobGovCode2 +
          "," +
          self.GovCodeModal.form.jobGovCode3 +
          "," +
          self.GovCodeModal.form.jobGovCode4,
        goV_CODE: self.GovCodeModal.form.govCode4
          ? self.GovCodeModal.form.govCode4
          : self.GovCodeModal.form.govCode3
          ? self.GovCodeModal.form.govCode3
          : self.GovCodeModal.form.govCode2
          ? self.GovCodeModal.form.govCode2
          : self.GovCodeModal.form.govCode1
          ? self.GovCodeModal.form.govCode1
          : "",
        goV_CODE_STR:
          self.GovCodeModal.form.govCode1 +
          "," +
          self.GovCodeModal.form.govCode2 +
          "," +
          self.GovCodeModal.form.govCode3 +
          "," +
          self.GovCodeModal.form.govCode4,
        neW_GOV_CODE: self.GovCodeModal.form.newJobGovCode4
          ? self.GovCodeModal.form.newJobGovCode4
          : self.GovCodeModal.form.newJobGovCode3
          ? self.GovCodeModal.form.newJobGovCode3
          : self.GovCodeModal.form.newJobGovCode2
          ? self.GovCodeModal.form.newJobGovCode2
          : self.GovCodeModal.form.newJobGovCode1
          ? self.GovCodeModal.form.newJobGovCode1
          : "",
        neW_GOV_CODE_STR:
          self.GovCodeModal.form.newJobGovCode1 +
          "," +
          self.GovCodeModal.form.newJobGovCode2 +
          "," +
          self.GovCodeModal.form.newJobGovCode3 +
          "," +
          self.GovCodeModal.form.newJobGovCode4,
        idn: self.GovCodeModal.form.idn,
        userid: self.loginInfo.id,
        arrivE_DATE: self.GovCodeModal.form.arriveDate,
        leavE_DATE: self.GovCodeModal.form.leaveDate,
        leavE_REASON: self.GovCodeModal.form.leave_Reason,
        leave: self.GovCodeModal.form.leave,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "機關變動-存檔",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      Object.keys(postData).map(
        (k) =>
          (postData[k] =
            typeof postData[k] == "string" ? postData[k].trim() : postData[k])
      );
      // console.log(JSON.stringify(postData));
      A101_GovCodeEditSave(postData).then((rData) => {
        if (rData.result) {
          self.Alert.show = true;
          self.Alert.title = "訊息";
          self.Alert.txt = ["修改成功"];
          self.Alert.BtnConfirm = () => {
            self.Alert.show = false;
            self.GovCodeModal.show = false;
            self.doQuery();
          };
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = [rData.messages[0]];
          //self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //第三頁服務機關變動 重填
    btnGovModalClear: function () {
      const self = this;
      self.GovCodeModal.form = {
        pkno: self.GovCodeModal.PreData.pkno,
        govCode1:
          self.form.govCode1 == ""
            ? sessionStorage.getItem("Session_GovCode")
            : self.form.jobGovCode1, //"311000000F",
        govCode2: self.form.govCode2,
        govCode3: self.form.govCode3,
        govCode4: self.form.govCode4,
        jobGovCode1:
          self.form.jobGovCode1 == ""
            ? sessionStorage.getItem("Session_GovCode")
            : self.form.govCode1,
        jobGovCode2: self.form.jobGovCode2,
        jobGovCode3: self.form.jobGovCode3,
        jobGovCode4: self.form.jobGovCode4,
        idn: self.GovCodeModal.form.idn,
        name: self.GovCodeModal.form.name,
        arriveDate: self.GovCodeModal.form.arriveDate,
        leaveDate: "",
        //現職狀況
        leave: "",
        //備註
        leave_Reason: "",
        newJobGovCode1: "", //self.GovCodeModal.form.newJobGovCode1,
        newJobGovCode2: "",
        newJobGovCode3: "",
        newJobGovCode4: "",
      };
    },
    //匯入頁
    ImportModalOnFileChange: function (event) {
      const self = this;
      self.ImportModal.form.updloaD_FILE = event.target.files[0];
    },
    //匯入頁 按紐匯入
    ImportModalBtnImport: function () {
      const self = this;
      if (self.ImportModal.form.updloaD_FILE) {
        let formData = new FormData();
        formData.append("UPDLOAD_FILE", self.ImportModal.form.updloaD_FILE);
        formData.append("LogInfo.Id", self.loginInfo.id);
        formData.append("LogInfo.PrgCode", self.pageData.PrgName);
        formData.append("LogInfo.Token", self.loginInfo.token);
        formData.append("LogInfo.ActCd", "匯入");
        formData.append("LogInfo.ServiceUnit", self.pageData.ServiceUnit);
        A101_Import(formData).then((rData) => {
          if (rData.result) {
            self.Alert.show = true;
            self.Alert.title = "訊息";
            self.Alert.txt = [rData.messages[0]]; //"匯入成功";
            self.Alert.BtnConfirm = () => {
              self.Alert.show = false;
            };
          } else {
            self.Alert.show = true;
            self.Alert.title = "錯誤";
            self.Alert.txt = [rData.messages[0]]; //"匯入失敗";
            self.Alert.BtnConfirm = () => (self.Alert.show = false);
          }
        });
      } else {
        self.Alert.show = true;
        self.Alert.title = "訊息";
        self.Alert.txt = ["請先選取匯入檔案"];
        self.Alert.BtnConfirm = () => (self.Alert.show = false);
      }
    },
    //匯出頁 按紐匯出
    ExportModalBtnExport: function () {
      const self = this;
      let postData = {
        syear: self.ExportModal.form.syear,
        jobgov: self.ExportModal.form.jobGovCode4
          ? self.ExportModal.form.jobGovCode4
          : self.ExportModal.form.jobGovCode3
          ? self.ExportModal.form.jobGovCode3
          : self.ExportModal.form.jobGovCode2
          ? self.ExportModal.form.jobGovCode2
          : self.ExportModal.form.jobGovCode1
          ? self.ExportModal.form.jobGovCode1
          : "",
        jobgovcheck: parseInt(self.ExportModal.form.jobGovCheck),
        idn: self.ExportModal.form.idn,
        name: self.ExportModal.form.name,
        leave: self.ExportModal.form.leave,
        LogInfo: {
          Id: self.loginInfo.id,
          PrgCode: self.pageData.PrgName,
          ActCd: "匯出",
          ServiceUnit: self.pageData.ServiceUnit,
          Token: self.loginInfo.token,
        },
      };
      // console.log(JSON.stringify(postData));
      A101_PrintReport(postData).then((rData) => {
        if (rData) {
          let link = document.createElement("a");
          link.download = self.pageData.MenuName;
          link.href =
            "data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64," +
            rData;
          // link.href = "data:application/vnd.openxmlformats-officedocument.wordprocessingml.document;base64," + rData;
          link.click();
        } else {
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = "匯出失敗";
          //self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
    //匯出頁 重填
    ExportModalBtnClear: function () {
      const self = this;
      self.ExportModal.form = {
        syear: String(new Date().getFullYear() - 1911),
        jobGovCode1: self.form.jobGovCode1,
        jobGovCode2: self.form.jobGovCode2,
        jobGovCode3: self.form.jobGovCode3,
        jobGovCode4: self.form.jobGovCode4,
        jobGovCheck: "0",
        idn: "",
        name: "",
        //現職狀況
        leave: "",
      };
    },
    //分頁防呆檢查
    checkPage: function (currentpage, pagesize) {
      const self = this;
      let pageErrorMsg = [];
      if (currentpage) {
        if (isNaN(parseInt(currentpage))) {
          pageErrorMsg.push("頁數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫頁數");
      }
      if (pagesize) {
        if (isNaN(parseInt(pagesize))) {
          pageErrorMsg.push("筆數格式錯誤");
        }
      } else {
        pageErrorMsg.push("請填寫每頁筆數");
      }
      if (pageErrorMsg.length) {
        self.Alert.show = true;
        self.Alert.title = "錯誤";
        self.Alert.txt = pageErrorMsg;
        self.Alert.BtnConfirm = () => {
          self.Alert.show = false;
        };
        return false;
      }
      return true;
    },
    //第一頁
    GovCode1Change: function () {
      const self = this;
      self.form.govCode2 = "";
      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode2s = [];
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode2Change: function () {
      const self = this;

      self.form.govCode3 = "";
      self.form.govCode4 = "";
      self.dropDownList.govCode3s = [];
      self.dropDownList.govCode4s = [];
    },
    GovCode3Change: function () {
      const self = this;
      self.form.govCode4 = "";
      self.dropDownList.govCode4s = [];
    },
    JobGovCode1Change: function () {
      const self = this;
      self.form.jobGovCode2 = "";
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode2s = [];
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode2Change: function () {
      const self = this;
      self.form.jobGovCode3 = "";
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode3s = [];
      self.dropDownList.jobGovCode4s = [];
    },
    JobGovCode3Change: function () {
      const self = this;
      self.form.jobGovCode4 = "";
      self.dropDownList.jobGovCode4s = [];
    },
    DetailModalGovCode1Change: function () {
      const self = this;
      self.DetailModal.form.govCode2 = "";
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode2s = [];
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalGovCode2Change: function () {
      const self = this;
      self.DetailModal.form.govCode3 = "";
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode3s = [];
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalGovCode3Change: function () {
      const self = this;
      self.DetailModal.form.govCode4 = "";
      self.DetailModal.dropDownList.govCode4s = [];
    },
    DetailModalJobGovCode1Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode2 = "";
      self.DetailModal.form.jobGovCode3 = "";
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode2s = [];
      self.DetailModal.dropDownList.jobGovCode3s = [];
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    DetailModalJobGovCode2Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode3 = "";
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode3s = [];
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    DetailModalJobGovCode3Change: function () {
      const self = this;
      self.DetailModal.form.jobGovCode4 = "";
      self.DetailModal.dropDownList.jobGovCode4s = [];
    },
    GetSearchRGovCode: function (newValue, num) {
      const self = this;

      if (self.Numm <= num && newValue != "") {
        self.Numm = num;

        self.GetSearchRGovCodeNext(newValue);

        // if (self.Numm == 1) self.Nummdata1 = newValue;
        // if (self.Numm == 2) self.Nummdata2 = newValue;
        // if (self.Numm == 3) self.Nummdata3 = newValue;
        // if (self.Numm == 4) self.Nummdata4 = newValue;

        // if (self.Numm == 1) self.GetSearchRGovCodeNext(self.Nummdata1);
        // if (self.Numm == 2) self.GetSearchRGovCodeNext(self.Nummdata2);
        // if (self.Numm == 3) self.GetSearchRGovCodeNext(self.Nummdata3);
        // if (self.Numm == 4) self.GetSearchRGovCodeNext(self.Nummdata4);

        // const data1 =
        //   num == 1
        //     ? () => {
        //         self.GetSearchRGovCodeNext(self.Nummdata1);
        //       }
        //     : () => {};
        // const data2 =
        //   num == 2
        //     ? () => {
        //         self.GetSearchRGovCodeNext(self.Nummdata2);
        //       }
        //     : () => {};
        // const data3 =
        //   num == 3
        //     ? () => {
        //         self.GetSearchRGovCodeNext(self.Nummdata3);
        //       }
        //     : () => {};
        // const data4 =
        //   num == 4
        //     ? () => {
        //         self.GetSearchRGovCodeNext(self.Nummdata4);
        //       }
        //     : () => {};

        // WaitEnd.methods.send(
        //   () => {
        //     data1();
        //   },
        //   () => {
        //     WaitEnd.methods.send(
        //       () => {
        //         data2();
        //       },
        //       () => {
        //         WaitEnd.methods.send(
        //           () => {
        //             data3();
        //           },
        //           () => {
        //             data4();
        //           }
        //         );
        //       }
        //     );
        //   }
        // );

        ////async await?
      }
    },
    GetSearchRGovCodeNext: function (newValue) {
      const self = this;
      let GovCode = { GOV_CODE: newValue };

      SearchRGovCode(GovCode).then((rData) => {
        if (rData.returnObject.length > 0) {
          self.DetailModal.form.govCode1 =
            rData.returnObject[0].rGovCodeStr.split(",")[0];
          self.DetailModal.form.govCode2 =
            rData.returnObject[0].rGovCodeStr.split(",")[1];
          self.DetailModal.form.govCode3 =
            rData.returnObject[0].rGovCodeStr.split(",")[2];
          self.DetailModal.form.govCode4 =
            rData.returnObject[0].rGovCodeStr.split(",")[3];
        } else if (newValue != "") {
          self.DetailModal.form.govCode1 = "";
          self.DetailModal.form.govCode2 = "";
          self.DetailModal.form.govCode3 = "";
          self.DetailModal.form.govCode4 = "";
          self.Alert.show = true;
          self.Alert.title = "錯誤";
          self.Alert.txt = ["此服務機關未有受理申報機構，請洽政風人員確認"];
          //self.Alert.txt = rData.messages;
          self.Alert.BtnConfirm = () => (self.Alert.show = false);
        }
      });
    },
  },
  created() {
    const self = this;
    //RoleAuthorizeMenu
    const Menu = getMenu(self.pageData.PrgName);
    if (Menu) {
      self.pageData.MenuIndex = Menu.menuIndex;
      self.pageData.MenuName = Menu.menuName;
    } else {
      self.Alert.show = true;
      self.Alert.title = "訊息";
      self.Alert.txt = ["無進入此頁權限，請洽詢管理員!!"];
      self.Alert.BtnConfirm = () => {
        self.Alert.show = false;
        self.$router.go(-1);
      };
    }
    //console.log("created :GovCodeInit");
    self.GovCodeInit(self.form);
    self.JobGovCodeInit(self.form);
    self.getSearchGovCode1();
    self.getSearchJobGovCode1();
    self.getOnJob();
    //console.log("created :btnDetailClear");
    self.btnDetailClear();
  },
  watch: {
    "form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode2(newValue);
    },
    "form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode3(newValue);
    },
    "form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchGovCode4(newValue);
    },
    "form.jobGovCode1": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode2(newValue);
    },
    "form.jobGovCode2": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode3(newValue);
    },
    "form.jobGovCode3": function (newValue, oldValue) {
      if (newValue != "") this.getSearchJobGovCode4(newValue);
    },
    "form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.reQuery("", "");
      }
    },
    "DetailModal.form.govCode1": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode2(newValue);
    },
    "DetailModal.form.govCode2": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode3(newValue);
    },
    "DetailModal.form.govCode3": function (newValue, oldValue) {
      if (newValue != "") this.modalGetSearchGovCode4(newValue);
    },
    "DetailModal.form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      if (newValue != "") {
        self.modalGetSearchJobGovCode2(newValue);
      }
      self.DetailModal.form.govCode1 = newValue;
      self.GetSearchRGovCode(newValue, 1);
    },
    "DetailModal.form.jobGovCode2": function (newValue, oldValue) {
      const self = this;
      if (newValue != "") {
        self.modalGetSearchJobGovCode3(newValue);
      }
      self.DetailModal.form.govCode2 = newValue;
      self.GetSearchRGovCode(newValue, 2);
    },
    "DetailModal.form.jobGovCode3": function (newValue, oldValue) {
      const self = this;
      if (newValue != "") {
        self.modalGetSearchJobGovCode4(newValue);
      }
      self.DetailModal.form.govCode3 = newValue;
      self.GetSearchRGovCode(newValue, 3);
    },
    "DetailModal.form.jobGovCode4": function (newValue, oldValue) {
      const self = this;
      self.DetailModal.form.govCode4 = newValue;
      self.GetSearchRGovCode(newValue, 4);
    },
    "GovCodeModal.form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.jobGovCode2 = "";
        self.GovCodeModal.form.jobGovCode3 = "";
        self.GovCodeModal.form.jobGovCode4 = "";
        self.GovCodeModal.dropDownList.jobGovCode2s = [];
        self.GovCodeModal.dropDownList.jobGovCode3s = [];
        self.GovCodeModal.dropDownList.jobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.GovCodeModal.form.jobGovCode2 = "";
          self.GovCodeModal.form.jobGovCode3 = "";
          self.GovCodeModal.form.jobGovCode4 = "";
          self.GovCodeModal.dropDownList.jobGovCode2s = [];
          self.GovCodeModal.dropDownList.jobGovCode3s = [];
          self.GovCodeModal.dropDownList.jobGovCode4s = [];
        }
        self.govModalGetSearchJobGovCode2(newValue);
      }
    },
    "GovCodeModal.form.jobGovCode2": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.jobGovCode3 = "";
        self.GovCodeModal.form.jobGovCode4 = "";
        self.GovCodeModal.dropDownList.jobGovCode3s = [];
        self.GovCodeModal.dropDownList.jobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.GovCodeModal.form.jobGovCode3 = "";
          self.GovCodeModal.form.jobGovCode4 = "";
          self.GovCodeModal.dropDownList.jobGovCode3s = [];
          self.GovCodeModal.dropDownList.jobGovCode4s = [];
        }
        self.govModalGetSearchJobGovCode3(newValue);
      }
    },
    "GovCodeModal.form.jobGovCode3": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.jobGovCode4 = "";
        self.GovCodeModal.dropDownList.jobGovCode4s = [];
      } else {
        self.govModalGetSearchJobGovCode4(newValue);
      }
    },
    "GovCodeModal.form.newJobGovCode1": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.newJobGovCode2 = "";
        self.GovCodeModal.form.newJobGovCode3 = "";
        self.GovCodeModal.form.newJobGovCode4 = "";
        self.GovCodeModal.dropDownList.newJobGovCode2s = [];
        self.GovCodeModal.dropDownList.newJobGovCode3s = [];
        self.GovCodeModal.dropDownList.newJobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.GovCodeModal.form.newJobGovCode2 = "";
          self.GovCodeModal.form.newJobGovCode3 = "";
          self.GovCodeModal.form.newJobGovCode4 = "";
          self.GovCodeModal.dropDownList.newJobGovCode2s = [];
          self.GovCodeModal.dropDownList.newJobGovCode3s = [];
          self.GovCodeModal.dropDownList.newJobGovCode4s = [];
        }
        self.govModalGetSearchNewJobGovCode2(newValue);
      }
    },
    "GovCodeModal.form.newJobGovCode2": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.newJobGovCode3 = "";
        self.GovCodeModal.form.newJobGovCode4 = "";
        self.GovCodeModal.dropDownList.newJobGovCode3s = [];
        self.GovCodeModal.dropDownList.newJobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.GovCodeModal.form.newJobGovCode3 = "";
          self.GovCodeModal.form.newJobGovCode4 = "";
          self.GovCodeModal.dropDownList.newJobGovCode3s = [];
          self.GovCodeModal.dropDownList.newJobGovCode4s = [];
        }
        self.govModalGetSearchNewJobGovCode3(newValue);
      }
    },
    "GovCodeModal.form.newJobGovCode3": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.GovCodeModal.form.newJobGovCode4 = "";
        self.GovCodeModal.dropDownList.newJobGovCode4s = [];
      } else {
        self.govModalGetSearchNewJobGovCode4(newValue);
      }
    },
    "ExportModal.form.jobGovCode1": function (newValue, oldValue) {
      const self = this;
      debugger;
      if (newValue != oldValue) {
        self.ExportModal.form.jobGovCode2 = "";
        self.ExportModal.form.jobGovCode3 = "";
        self.ExportModal.form.jobGovCode4 = "";
        self.ExportModal.dropDownList.jobGovCode2s = [];
        self.ExportModal.dropDownList.jobGovCode3s = [];
        self.ExportModal.dropDownList.jobGovCode4s = [];
      }
      self.ExportModalGetSearchJobGovCode2(newValue);
    },
    "ExportModal.form.jobGovCode2": function (newValue, oldValue) {
      const self = this;
      debugger;
      if (newValue === "") {
        self.ExportModal.form.jobGovCode3 = "";
        self.ExportModal.form.jobGovCode4 = "";
        self.ExportModal.dropDownList.jobGovCode3s = [];
        self.ExportModal.dropDownList.jobGovCode4s = [];
      } else {
        if (newValue != oldValue) {
          self.ExportModal.form.jobGovCode3 = "";
          self.ExportModal.form.jobGovCode4 = "";
          self.ExportModal.dropDownList.jobGovCode3s = [];
          self.ExportModal.dropDownList.jobGovCode4s = [];
        }
        self.ExportModalGetSearchJobGovCode3(newValue);
      }
    },
    "ExportModal.form.jobGovCode3": function (newValue, oldValue) {
      const self = this;
      if (newValue === "") {
        self.ExportModal.form.jobGovCode4 = "";
        self.ExportModal.dropDownList.jobGovCode4s = [];
      } else {
        self.ExportModalGetSearchJobGovCode4(newValue);
      }
    },
    "LogModal.form.currentpage": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnSearchLog(this.LogModal.form.idn);
      }
    },
    "LogModal.form.pagesize": function (newValue, oldValue) {
      if (newValue != oldValue) {
        this.btnSearchLog(this.LogModal.form.idn);
      }
    },
    "form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.form.idn = newValue.toUpperCase();
      }
    },
    "DetailModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.DetailModal.form.idn = newValue.toUpperCase();
      }
    },
    "GovCodeModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.GovCodeModal.form.idn = newValue.toUpperCase();
      }
    },
    "ExportModal.form.idn": function (newValue, oldValue) {
      const self = this;
      if (newValue != oldValue) {
        self.ExportModal.form.idn = newValue.toUpperCase();
      }
    },
  },
};
</script>

<style scoped src="@/assets/css/Pdis.css" />
